import infoProperties from './info_properties';

const data = {
  type: 'object',
  required: ['info', 'dealId'],
  properties: {
    dealId: { type: 'string' },
    info: { type: 'object', properties: infoProperties },
  },
};
const co_signer_request_schema = {
  new_co_signer_request: {
    $id: 'newCoSignerRequest',
    type: 'object',
    required: ['applicantInfo', 'dealId'],
    properties: {
      captchaToken: { type: 'string', nullable: true },
      ...infoProperties,
      dealId: { type: 'string' },
    },
  },
  update_co_signer_request: {
    $id: 'updatenewCoSignerRequest',
    type: 'object',
    required: ['_id', 'data'],
    properties: {
      _id: { type: 'string' },
      data,
      availableToRolesIds: {
        type: 'array',
        nullable: true,
        items: {
          type: 'string',
        },
      },
      approved: {
        type: 'boolean',
        nullable: true,
      },
      approvedAt: {
        type: 'string',
        nullable: true,
      },
      approvedByUserId: {
        type: 'string',
        nullable: true,
      },
    },
  },
};

export default co_signer_request_schema;
